import React, { useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

function NavBar() {
  const [expanded, setExpanded] = useState(false);
  const [showResources, setShowResources] = useState(false);

  const closeMenu = () => {
    setExpanded(false);
    setShowResources(false);
  };
  return (
    <Navbar
      expand="lg"
      sticky="top"
      className="premium-navbar"
      expanded={expanded}
      onToggle={(value) => setExpanded(value)}
    >
      <Container
        style={{
          maxWidth: "1400px",
        }}
      >
        <Navbar.Brand as={NavLink} to="/" onClick={closeMenu}
        >
          <img
            src={logo}
            alt="EkritFly"
            style={{
              height: "48px",
            }}
          />
        </Navbar.Brand>

        <Navbar.Toggle />

        <Navbar.Collapse>
          <Nav className="ms-auto align-items-lg-center premium-nav-links">

            <NavLink
              className="nav-link"
              to="/services"
              onClick={closeMenu}

            >
              Services
            </NavLink>

            <NavLink
              className="nav-link"
              to="/industries"
              onClick={closeMenu}

            >
              Industries
            </NavLink>

            <NavDropdown
              title="Resources"
              id="resources-dropdown"
              show={showResources}
              onToggle={(isOpen) => setShowResources(isOpen)}
            >
              <NavDropdown.Item
                as={NavLink}
                to="/case-studies"
                onClick={closeMenu}

              >
                Case Studies
              </NavDropdown.Item>

              <NavDropdown.Item
                as={NavLink}
                to="/blog"
                onClick={closeMenu}

              >
                Blog
              </NavDropdown.Item>
            </NavDropdown>

            <NavLink
              className="nav-link"
              to="/about"
              onClick={closeMenu}

            >
              About
            </NavLink>

            <NavLink
              to="/free-growth-audit"
              className="premium-navbar-cta"
              onClick={closeMenu}

            >
              Book Strategy Call
            </NavLink>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;